var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3989 14.219V21.598H18.1209V14.713C18.1209 12.983 17.5019 11.803 15.9539 11.803C14.7719 11.803 14.0679 12.599 13.7589 13.368C13.6459 13.643 13.6169 14.026 13.6169 14.411V21.598H9.33694C9.33694 21.598 9.39494 9.938 9.33694 8.729H13.6169V10.553L13.5889 10.595H13.6169V10.553C14.1849 9.678 15.1999 8.427 17.4729 8.427C20.2879 8.427 22.3989 10.267 22.3989 14.219ZM4.86094 2.526C3.39794 2.526 2.43994 3.486 2.43994 4.749C2.43994 5.984 3.36994 6.973 4.80494 6.973H4.83294C6.32594 6.973 7.25294 5.984 7.25294 4.749C7.22694 3.486 6.32694 2.526 4.86194 2.526H4.86094ZM2.69394 21.598H6.97194V8.729H2.69394V21.598Z",
    fill: "#252B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.59c69546f31d0a4960b95ae15ac4b60e.svg";
export { ForwardRef as ReactComponent };